//
// Polyfills
//

import Promise from 'promise-polyfill'; // Promise polyfill
import setAsap from 'setasap'; // Performance optimization for promise in ie and edge
Promise._immediateFn = setAsap;

import { tns } from 'tiny-slider/src/tiny-slider';


import 'bootstrap/js/src/tab';
import 'bootstrap/js/src/collapse';
import {selection} from "../../../../../../../typo3/sysext/core/Resources/Public/JavaScript/Contrib/d3-selection";



/*
const collapseElementList = document.querySelectorAll('.collapse')
const collapseList = [...collapseElementList].map(collapseEl => new bootstrap.Collapse(collapseEl))
*/

require ('./three');

/*

document.addEventListener("DOMContentLoaded", function() {

    let links = document.querySelectorAll('a');
    links.forEach(function(item){
        if (item.getAttribute('data-mailto-token') != null) {
            item.innerHTML = item.innerHTML.replace('@~@', '@');
        }
    });

});*/

//
// jQuery
//

// var $ = require("jquery");
// window.jQuery = $;
// window.$ = $;


//
// Requirements
//

require('jquery/src/core/init');
require('jquery/src/selector');
// require('jquery/src/traversing');
// require('jquery/src/callbacks');
// require('jquery/src/deferred');
// require('jquery/src/deferred/exceptionHook');
require('jquery/src/core/ready');
require('jquery/src/data'); // .data()
// require('jquery/src/queue');
// require('jquery/src/queue/delay');
require('jquery/src/attributes'); // .addCss()
// require('jquery/src/event');
// require('jquery/src/event/focusin');
require('jquery/src/manipulation'); // .append()
// require('jquery/src/manipulation/_evalUrl');
// require('jquery/src/wrap');
require('jquery/src/css'); // .css()
require('jquery/src/css/hiddenVisibleSelectors'); // .show(), .hide()
// require('jquery/src/serialize');
// require('jquery/src/ajax'); // .ajax()
// require('jquery/src/ajax/xhr'); // .ajax()
// require('jquery/src/ajax/script');
// require('jquery/src/ajax/jsonp');
// require('jquery/src/ajax/load');
// require('jquery/src/core/parseXML');
// require('jquery/src/core/parseHTML');
// require('jquery/src/effects');
// require('jquery/src/effects/animatedSelector');
require('jquery/src/offset');
require('jquery/src/dimensions');
require('jquery/src/deprecated');
// require('jquery/src/exports/amd');
require('jquery/src/exports/global');




import hcOffcanvasNav from 'hc-offcanvas-nav';

document.addEventListener('DOMContentLoaded', function() {
    new hcOffcanvasNav('#main-nav', {
        disableAt: 991,
        navTitle: 'Menü',
        customToggle: $('.navbar-toggler'),
        levelTitles: true,
        levelTitleAsBack: true,
        removeOriginalNav: true,
        keepClasses: true,
    });
});


//
// Intersection observer for animation content elements when first displayed
//

/**
 * @type {NodeListOf<Element>}
 */
let animationObjs = document.querySelectorAll('.animate');

/**
 * @type {IntersectionObserver}
 */
const animationObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        entry.target.classList.toggle('animated', entry.isIntersecting);
        entry.target.classList.toggle(entry.target.dataset.bdAnimateClass ?? 'fadeInUp', entry.isIntersecting);
        if (entry.isIntersecting) {
            animationObserver.unobserve(entry.target);
        }
    });
}, {
    // threshold: 1, // when 1ßß% is visible
    rootMargin: "0px 0px -80px 0px",
    // or `0px 0px ${window.innerHeight / 2} 0px`
    // for detect middle screen height
    threshold: 0
});

animationObjs.forEach(obj => {
    animationObserver.observe(obj);
});




//
// Menu mutation observer
//
var config = { attributes: true, childList: true, characterData: true, attributeFilter : ['class', '.collapse'], };
var navbarSubSelector = ".page-header .navbar-sub";
var navbarSubs = document.querySelectorAll(navbarSubSelector);
/*

var animationObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.target.classList.contains('collapse')) {

        }
        console.log(mutation.target.classList.contains('collapse'))
        var attributeValue = $(mutation.target).prop(mutation.attributeName);
        var attributeValueArray = attributeValue.split(" ");

        if (attributeValueArray.includes('collapse')) {
            console.log(attributeValue);
            console.log("Class attribute changed to:", attributeValue);
            console.log('---')
        }
    });
});


navbarSubs.forEach(item => {
    animationObserver.observe(item, {
        attributes: true,
        attributeFilter: ['class']
    });
});
*/




let pagePos = $(window).scrollTop();

$(window).on("scroll", function ()  {
    var obj = $(".page-header-infos"),
        pos = $(this).scrollTop();

    if (pos > pagePos && pos > obj.outerHeight())
        obj.addClass("toggled"); // Scroll down
    else
        obj.removeClass("toggled"); // Scroll up

    pagePos = pos;
});




$(document).on('click', '.navbar .nav-link' , function () {

    if ($(this).attr('aria-expanded') == "true") {
        $('body').addClass('no-scroll');
        $('.page-header-overlay').show();

    } else {
        $('body').removeClass('no-scroll show-overlay');
        $('.page-header-overlay').hide();
    }
});

$(document).on("classChanged", function () {
    // alert("Button Style Change event fired");
});

$(window).on('resize' , function () {
    let headerHeight = $('.page-header').first().outerHeight();
    $('body').style({
        '--header-height': headerHeight
    });
});











//
// Functions
//

function initIsotope(classNames) {
    if ($(classNames).length) {
        return import(/* webpackChunkName: "module-isotope" */ './module-isotope').catch(err => console.error(err));
    }
}

function initResponsiveBgImages(classNames) {
    if ($(classNames).length) {
        return import(/* webpackChunkName: "module-bgImage" */ './module-bgImage').catch(err => console.error(err));
    }
}

function initTabMenu(classNames) {
    if ($(classNames).length) {
        return import(/* webpackChunkName: "module-tabMenu" */ './module-tabMenu').catch(err => console.error(err));
    }
}

function initLottiePlayer(selector) {
    if ($(selector).length) {
        return import(/* webpackChunkName: "module-lottie-player" */ './module-lottie-player').then((module) => {




            //console.log(module.default.LottiePlayer);
        }).catch(err => console.error(err));
    }
}

function initDirectPopups(classNames) {
    let $objs = $(classNames);
    if ($objs.length) {

        $objs.modal('show');

    }
}

function initScrollDownBtn() {
    $(document).on('click', ".scroll-down-link", function(e) {
        e.preventDefault();
        $('html,body').stop().animate({scrollTop:$($(this).attr('href')).offset().top}, 300, 'swing', function() {

        });
    });
}

function initMenuToggle() {
    $(document).on('click', '[data-ariatoggle="#page-menu"],[data-ariatoggle="#page-mobile-menu"]', function (e) {
        e.preventDefault();

        let $target = $($(this).attr('data-ariatoggle'));

        $target.attr('aria-expanded', ($target.attr('aria-expanded') === 'true' ? 'false' : 'true'));

        if ($(this).attr('data-ariatoggle') === '#page-mobile-menu') {
            $('body').toggleClass('noscroll-mobile-nav');
        }
    });
}


function initColorSwitchContainer(classNames) {
    if ($(classNames).length) {
        return import(/* webpackChunkName: "module-colorSwitchContainer" */ './module-colorSwitchContainer').catch(err => console.error(err));
    }
}

function initCookieBanner() {
    return import(/* webpackChunkName: "module-cookieBanner" */ './module-cookieBanner').catch(err => console.error(err));
}


function initTinySliderInfo(classNames) {
    let $objs = $(classNames);


    if ($objs.length > 0 ) {
        $(function() {
            $objs.each(function() {
                var $slider = $(this),
                    $parent = $(this).parents('.ce-default').first(),
                    tnsId = $slider.attr('data-tnsid'),
                    // customControlsContainer = $parent.find('.tns-custom-controls').first().get(0),
                    customNavContainer = $parent.find('.tns-custom-thumbnails').first().get(0);


                var slider = tns({
                    autoplay: true,
                    autoplayButtonOutput: false,
                    autoplayHoverPause: false,
                    autoplayResetOnVisibility: false,
                    autoplayTimeout: 6000,
                    animateIn: 'fadeInTopRight',
                    animateOut: 'fadeOutBottomRight',

                    container: $(this).get(0),
                    controls: false,
                    controlsContainer: false,
                    items: 1,
                    // mode: "gallery",
                    mouseDrag: true,
                    nav: true,
                    navAsThumbnails: true,
                    navContainer: customNavContainer,
                    swipeAngle: false,
                    touch: false,
                    useLocalStorage: false,

                    mode: 'gallery',
                    speed: 1000,

                    autoHeight: false,
                });



                var e = $parent.find('.thumbnails').get(0);

                var mutationObserver = new MutationObserver(function (mutationsList, observer) {

                    for(let mutation of mutationsList) {
                        if(mutation.attributeName === "class"){
                            // console.log(mutation.target);
                            if (mutation.target.classList.contains('tns-nav-active') ) {
                                $parent.find('.tns-additional-info[data-tnsid="'+ $slider.data('tnsid') +'"][data-tnsslideindex="'+ mutation.target.dataset.nav +'"]').addClass('active');
                            } else {
                                $parent.find('.tns-additional-info[data-tnsid="'+ $slider.data('tnsid') +'"][data-tnsslideindex="'+ mutation.target.dataset.nav +'"]').removeClass('active');
                            }
                        }
                    }
                })

                mutationObserver.observe(e, {
                    attributes: true,
                    attributeFilter: ['class'],
                    childList: true,
                    subtree: true,
                    characterData: false
                })


                $parent.find('.tns-additional-info[data-tnsid="'+ tnsId +'"][data-tnsslideindex="0"]').addClass('active');


            });
        });

    }
}

function initMobileMenu(selector='') {
    if ($(selector).length) {


        // return import(/* webpackChunkName: "module-mobileMenu" */ './module-mobileMenu').then((module) => {
        //     console.log(selector)
        //     let mobileNav = new module.default(selector, {
        //         disableAt: 1024,
        //         customToggle: '.toggle',
        //         navTitle: 'All Categories',
        //         levelTitles: true,
        //         levelTitleAsBack: true
        //     });
        // }).catch(err => console.error(err));
    }
}

//
// Document ready
//
document.addEventListener('DOMContentLoaded', function() {




    initMobileMenu('#page-menu-mobile');

    initCookieBanner();
    initScrollDownBtn();
    initMenuToggle();
    initLottiePlayer('lottie-player');
    initResponsiveBgImages('[data-resbgimgcontainer]');
    initIsotope('.grid');
    initTabMenu('[data-bs-toggle="pill"]');
    initColorSwitchContainer('[data-theme-color]');

    initDirectPopups('.modal-direct-popup');

    initTinySliderInfo('.tns-slider-info');

    $(document).on('click', '.modal [data-fancybox]', function() {
        $(this).parents('.modal').first().modal('hide');
    });
});
